export const widowRegex = /(\s[a-zA-Z0-9_ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]{1,3})\s/g
import sanitizeHtml from 'sanitize-html'

const defaultAllowedAttributes = sanitizeHtml.defaults.allowedAttributes || {}
const defaultAnchorAttributes = defaultAllowedAttributes.a || []
const defaultImageAttributes = defaultAllowedAttributes.img || []

const buildRelAttribute = (value = '') => {
  const tokens = new Set(
    String(value)
      .split(/\s+/)
      .map((token) => token.trim())
      .filter(Boolean),
  )

  tokens.add('noopener')

  return Array.from(tokens).join(' ')
}

const iframeAllowedAttributes = [
  'src',
  'title',
  'width',
  'height',
  'allow',
  'allowfullscreen',
  'frameborder',
  'loading',
  'referrerpolicy',
]

// Style z Worda i innych edytorów (czcionka, rozmiar, interlinia, kolor, marginesy) - opis ma wyglądać jak reszta
// strony, więc przy `stripTypography` zostaje tylko to, co daje pasek edytora (wyrównanie, wcięcie list, podkreślenie).
const typographyStyleRegex =
  /^(font(-[a-z]+)?|line-height|letter-spacing|word-spacing|color|background(-color)?|margin(-[a-z]+)?|text-indent|mso-.*)$/i

const stripTypographyStyle = (style = '') =>
  style
    .split(';')
    .map((declaration) => declaration.trim())
    .filter((declaration) => declaration && !typographyStyleRegex.test(declaration.split(':')[0].trim()))
    .join('; ')

const stripTypographyTransform = (tagName, attribs) => {
  if (attribs.style === undefined) return { tagName, attribs }

  const { style, ...rest } = attribs
  const cleaned = stripTypographyStyle(style)

  return { tagName, attribs: cleaned ? { ...rest, style: cleaned } : rest }
}

const sanitize = (value, options = {}) => {
  if (typeof value !== 'string' || value === '') {
    return value || ''
  }

  const allowedTags = [
    ...sanitizeHtml.defaults.allowedTags,
    ...(options.allowIframe ? ['iframe'] : []),
    ...(options.allowImages ? ['img'] : []),
  ]

  return sanitizeHtml(value, {
    allowedTags: [...new Set(allowedTags)],
    allowedSchemesByTag: options.allowImages
      ? {
          ...(sanitizeHtml.defaults.allowedSchemesByTag || {}),
          img: [...new Set([...(sanitizeHtml.defaults.allowedSchemes || []), 'data'])],
        }
      : sanitizeHtml.defaults.allowedSchemesByTag,
    allowedAttributes: {
      ...defaultAllowedAttributes,
      '*': ['class', 'style', 'id'],
      a: [...new Set([...defaultAnchorAttributes, 'target', 'rel'])],
      img: [...new Set([...defaultImageAttributes, 'class', 'style'])],
      ...(options.allowIframe ? { iframe: iframeAllowedAttributes } : {}),
    },
    transformTags: {
      ...(options.stripTypography ? { '*': stripTypographyTransform } : {}),
      a: (tagName, attribs) => {
        const target = attribs.target || '_self'
        const rel = target === '_blank' ? buildRelAttribute(attribs.rel) : attribs.rel

        return {
          tagName,
          attribs: {
            ...attribs,
            target,
            ...(rel ? { rel } : {}),
          },
        }
      },
    },
    textFilter(text) {
      return typeof text === 'string' ? text.replace(widowRegex, '$1\u00A0') : text
    },
  })
}

export default {
  sanitize,
}
